import React, { useEffect, useState, useRef } from 'react';
import { Routes, Route } from 'react-router-dom';

import { Menu, Layout, Breadcrumb, Typography } from 'antd';
import type { MenuProps, MenuTheme } from 'antd/es/menu';
import { BankOutlined } from '@ant-design/icons';
// import Logo from "./../../assets/pngs/logo/Logo.png";
import Logo from './../../assets/pngs/logo/Logo.png';
import './layout.css';
import { AppRoutes } from '../../data';
import { useLocation, useNavigate } from 'react-router-dom';
import TopNavBar from './TopNav';
import PageTitle from './CurrentPageTitle';
// import MyComponent from "../../MyComponent";
import HomePage from '../../pages/HomePage';
import useAxiosPost from '../../hooks/useAxiosPost';
import { getUserType } from '../../helpers/userDetails';
const { Sider, Header, Content } = Layout;
const { Text } = Typography;
type MenuItem = Required<MenuProps>['items'][number];

const AppLayout = () => {
  const isLoggedIn = true; // Always true when this component is rendered (protected by routes)
  const [items, setItems] = useState<MenuItem[]>([]);
  const location = useLocation();
  const navigate = useNavigate();
  const [companyName, setCompanyName] = useState<string>('');
  const [companyCode, setCompanyCode] = useState<number | null>(null);
  const userType = getUserType();
  const isStaff = userType !== 'MASTER_ADMIN' && userType !== 'MASTER_NOC';

  // Fetch company name for staff users
  const [postGetCompanyName, getCompanyNameResponse, getCompanyNameError, getCompanyNameLoading] =
    useAxiosPost<ResponseProp>('auth/getCompanyName');

  const postGetCompanyNameRef = useRef(postGetCompanyName);
  useEffect(() => {
    postGetCompanyNameRef.current = postGetCompanyName;
  }, [postGetCompanyName]);

  useEffect(() => {
    const routes = AppRoutes();
    const _items = routes
      .filter((item: any) => item.show === true)
      .map((item: any) => {
        return {
          key: item.path,
          icon: <img src={item.icon} />,
          label: item.text,
        };
      });
    setItems(_items);
  }, []);
  const [mode, setMode] = useState<'vertical' | 'inline'>('inline');
  const [theme, setTheme] = useState<MenuTheme>('light');
  const [routes, setRoutes] = useState<any>([]);
  const [activePageTitle, setActivePageTitle] = useState<string | null>(null);

  useEffect(() => {
    setRoutes(AppRoutes());
  }, []);
  useEffect(() => {
    const routes = AppRoutes();
    const activeRoute = routes.find((item: any) => item.path.startsWith(location.pathname));
    console.log({ activeRoute });
    const currentPageTitle = activeRoute?.text || 'Dashboard';
    setActivePageTitle(currentPageTitle);
  }, [location]);

  // Fetch company name on mount if user is staff
  useEffect(() => {
    if (isStaff) {
      postGetCompanyNameRef.current({});
    }
  }, [isStaff]);

  // Update company name when response is received
  useEffect(() => {
    if (getCompanyNameResponse !== null) {
      const data: any = getCompanyNameResponse.responseData;
      if (data?.companyName) {
        setCompanyName(data.companyName);
      }
      if (data?.companyCode !== undefined && data?.companyCode !== null) {
        setCompanyCode(Number(data.companyCode));
      }
    }
  }, [getCompanyNameResponse]);
  return (
    <>
      <Layout>
        <Header
          style={{
            display: 'flex',
            alignItems: 'center',
            padding: '0px',
            height: '120px',
            background: 'white',
          }}
        >
          <div className="top-nav-bar-custom">
            <div className="logo">
              <img src={Logo} alt="Logo" />
              {activePageTitle !== null ? <PageTitle title={activePageTitle} /> : null}
            </div>
            <TopNavBar />
          </div>
        </Header>
        <Layout>
          <Sider className="side-bar-main" style={{ minHeight: '100vh' }} width={200}>
            {isStaff && companyName && (
              <div className="company-name-banner">
                <div className="company-name-content">
                  <BankOutlined className="company-icon" />
                  <div>
                    <Text className="company-name-text">{companyName}</Text>
                    {companyCode !== null && (
                      <Text className="company-name-text" style={{ display: 'block', fontSize: '12px' }}>
                        Code: {companyCode}
                      </Text>
                    )}
                  </div>
                </div>
              </div>
            )}
            <Menu
              mode="inline"
              selectedKeys={[location.pathname]}
              onClick={(e) => {
                console.log(e.key);
                navigate(e.key);
              }}
              defaultOpenKeys={['sub1']}
              style={{ height: '100%', borderRight: 0, width: 'inherit' }}
              defaultSelectedKeys={['1']}
              items={items}
              theme={theme}
            />
          </Sider>
          <Layout style={{ padding: '0 24px 24px' }}>
            <Content
              style={{
                padding: 24,
                margin: 0,
                minHeight: 280,
              }}
            >
              <Routes>
                <Route path="/" element={<HomePage />} />
                {isLoggedIn &&
                  routes.map((route: any) => {
                    return <Route path={route.path} key={Math.random()} element={<route.Component />} />;
                  })}
              </Routes>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </>
  );
};

export default AppLayout;
